module.exports = __webpack_public_path__ + "img/category-fundamentals-reverse.7d2a41eb.svg";